// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__vvekB","content":"styles_content__1pe63","selectAll":"styles_selectAll__1Bwy-"};